import { Config } from '@optimizely/optimizely-sdk';
import { createInstance, enums, setLogger } from '@optimizely/react-sdk';

import { DISPATCHED_OPT_EVENTS } from './constants/constants';
import { customLogger } from './customLogger';

export const createReactSDKInstance = (config: Config) => {
    setLogger({
        log: customLogger,
    });

    const reactSDKInstance = createInstance(config);

    const onDecision = ({ type, userId, attributes, decisionInfo }) => {
        if (typeof window === 'undefined') {
            return;
        }

        // Make sure data from session storage is an array
        const parsedSessionDispatchedEvents = JSON.parse(window.sessionStorage.getItem(DISPATCHED_OPT_EVENTS));
        const dispatchedEvents = Array.isArray(parsedSessionDispatchedEvents) ? parsedSessionDispatchedEvents : [];

        if (type === 'flag' && decisionInfo?.decisionEventDispatched) {
            const variantString = `${decisionInfo.flagKey}${decisionInfo.ruleKey}${decisionInfo.variationKey}`;
            // Make sure we don't dispatch the same event more that once per session
            if (!dispatchedEvents.includes(variantString)) {
                dispatchedEvents.push(variantString);
                window.sessionStorage.setItem(DISPATCHED_OPT_EVENTS, JSON.stringify(dispatchedEvents));
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'experience_impression',
                    exp_variant_string: variantString,
                });
            }
        }
    };

    reactSDKInstance.notificationCenter.addNotificationListener(enums.NOTIFICATION_TYPES.DECISION, onDecision);

    return reactSDKInstance;
};
